(() => {
  'use strict';
  if (window.ELookusWishlist) return;
  const node = document.getElementById('elw-config');
  if (!node) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch (_) { return; }
  if (!config || typeof config.key !== 'string' || !/^elookus:wishlist:theme:[1-9][0-9]*:v1$/.test(config.key)) return;
  const defaults = {
    add: 'Save {title} to wishlist', remove: 'Remove {title} from wishlist',
    open: 'Open wishlist ({count})', close: 'Close', empty: 'Your wishlist is empty.',
    loading: 'Loading your wishlist…', storageUnavailable: 'Your wishlist is saved only for this visit because browser storage is unavailable.',
    scriptError: 'Wishlist could not load. Please try again.', unavailable: 'Product no longer available',
    soldOut: 'Sold out', available: 'Available', removeItem: 'Remove', couldNotLoad: 'Could not load this product.', retry: 'Try again',
    currentPrice: 'Current price', from: 'From', viewProduct: 'View product',
    limitReached: 'You can save up to 100 products. Remove one to add another.'
  };
  function label(key, values) {
    let value = typeof config.labels?.[key] === 'string' ? config.labels[key] : (defaults[key] || key);
    Object.keys(values || {}).forEach((name) => { value = value.split('{' + name + '}').join(String(values[name])); });
    return value;
  }
  function entry(value) {
    if (!value || typeof value !== 'object' || !['string', 'number'].includes(typeof value.id)) return null;
    if (typeof value.id === 'number' && !Number.isSafeInteger(value.id)) return null;
    const id = String(value.id || '');
    const handle = typeof value.handle === 'string' ? value.handle : '';
    if (!/^[1-9][0-9]{0,19}$/.test(id) || handle.length > 255 || !/^[a-z0-9][a-z0-9-]*$/.test(handle)) return null;
    return { id, handle };
  }
  function parse(raw) {
    if (raw === null) return [];
    if (typeof raw !== 'string' || raw.length > 32768) throw new Error('Invalid storage');
    const values = JSON.parse(raw);
    if (!Array.isArray(values) || values.length > 100) throw new Error('Invalid storage');
    const seen = new Set();
    return values.map((value) => {
      const clean = entry(value);
      if (!clean || seen.has(clean.id)) throw new Error('Invalid storage');
      seen.add(clean.id);
      return clean;
    });
  }
  let items = [], persistent = true, app, pending, notice, noticeTimer;
  const listeners = new Set();
  function warn(message) {
    clearTimeout(noticeTimer);
    if (!notice) {
      notice = document.createElement('div');
      notice.className = 'elw-notice';
      notice.setAttribute('role', 'status');
      const text = document.createElement('span');
      const close = document.createElement('button');
      close.type = 'button';
      close.textContent = '×';
      close.setAttribute('aria-label', label('close'));
      close.addEventListener('click', () => { notice.hidden = true; });
      notice.append(text, close);
      document.body.append(notice);
    }
    notice.firstElementChild.textContent = message;
    notice.hidden = false;
    noticeTimer = setTimeout(() => { notice.hidden = true; }, 12000);
  }
  function storageFailed() {
    const wasPersistent = persistent;
    persistent = false;
    if (wasPersistent) warn(label('storageUnavailable'));
  }
  function read() {
    if (!persistent) return;
    try { items = parse(window.localStorage.getItem(config.key)); } catch (_) { storageFailed(); }
  }
  function saved(id) { return items.some((item) => item.id === String(id)); }
  function sync(scope = document) {
    const controls = [];
    if (scope.matches?.('[data-elw-toggle], [data-elw-open]')) controls.push(scope);
    controls.push(...scope.querySelectorAll('[data-elw-toggle], [data-elw-open]'));
    controls.forEach((button) => {
      if (button.hasAttribute('data-elw-toggle')) {
        const valid = entry({ id: button.dataset.productId, handle: button.dataset.productHandle });
        button.disabled = !valid;
        const pressed = !!valid && saved(valid.id);
        button.setAttribute('aria-pressed', String(pressed));
        button.setAttribute('aria-label', label(pressed ? 'remove' : 'add', { title: button.dataset.productTitle || '' }).trim());
      } else {
        button.disabled = false;
        button.setAttribute('aria-label', label('open', { count: items.length }));
        const count = button.querySelector('[data-elw-count]');
        if (count) { count.textContent = String(items.length); count.hidden = items.length === 0; }
      }
    });
    scope.querySelectorAll('[data-elw-storage-note]').forEach((note) => {
      note.hidden = persistent;
      note.textContent = persistent ? '' : label('storageUnavailable');
    });
  }
  function emit() {
    sync();
    listeners.forEach((listener) => listener());
  }
  function change(value, removeOnly) {
    const clean = entry(value);
    if (!clean) return;
    read();
    const index = items.findIndex((item) => item.id === clean.id);
    if (index >= 0) items.splice(index, 1);
    else if (!removeOnly) {
      if (items.length >= 100) { warn(label('limitReached')); emit(); return; }
      items.push(clean);
    }
    if (persistent) {
      try { window.localStorage.setItem(config.key, JSON.stringify(items)); } catch (_) { storageFailed(); }
    }
    emit();
  }
  function load() {
    if (app) return Promise.resolve(app);
    if (pending) return pending;
    pending = new Promise((resolve, reject) => {
      let url;
      try {
        url = new URL(config.asset, location.origin);
        if (url.protocol !== 'https:' || (url.origin !== location.origin && url.hostname !== 'cdn.shopify.com')) throw new Error('Invalid asset');
      } catch (_) { reject(new Error('Invalid asset')); return; }
      const script = document.createElement('script');
      let finished = false;
      const timeout = setTimeout(() => finish(false), 15000);
      function finish(ok) {
        if (finished) return;
        finished = true;
        clearTimeout(timeout);
        script.onload = script.onerror = null;
        if (ok && app) resolve(app);
        else { script.remove(); reject(new Error('Wishlist unavailable')); }
      }
      script.src = url.href;
      script.async = true;
      script.onload = () => finish(true);
      script.onerror = () => finish(false);
      document.head.append(script);
    }).catch((error) => { pending = null; throw error; });
    return pending;
  }
  window.ELookusWishlist = {
    config, label, entry, saved, warn,
    items: () => items.map((item) => ({ ...item })),
    persistent: () => persistent,
    remove: (value) => change(value, true),
    subscribe: (listener) => { listeners.add(listener); return () => listeners.delete(listener); },
    register: (drawer) => { if (drawer && typeof drawer.open === 'function') app = drawer; }
  };
  read();
  sync();
  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-elw-toggle], [data-elw-open]');
    if (!button || button.disabled) return;
    event.preventDefault();
    event.stopPropagation();
    const value = button.hasAttribute('data-elw-toggle') ? entry({ id: button.dataset.productId, handle: button.dataset.productHandle }) : null;
    button.setAttribute('aria-busy', 'true');
    load().then((drawer) => {
      if (value) change(value, false);
      else drawer.open(button);
    }).catch(() => { sync(); warn(label('scriptError')); })
      .finally(() => { button.removeAttribute('aria-busy'); });
  }, true);
  window.addEventListener('storage', (event) => {
    if (!persistent || (event.key !== config.key && event.key !== null)) return;
    try {
      if (event.storageArea && event.storageArea !== window.localStorage) return;
      items = parse(event.key === null ? null : event.newValue);
    } catch (_) { storageFailed(); }
    emit();
  });
  new MutationObserver((records) => {
    records.forEach((record) => {
      if (record.type === 'attributes') sync(record.target);
      record.addedNodes.forEach((added) => { if (added.nodeType === 1) sync(added); });
    });
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-product-id', 'data-product-handle', 'data-product-title', 'data-elw-toggle', 'data-elw-open'] });
})();
